import { IServiceEvent } from "../types/IServiceEvent";
import { Api } from "./api";

export const RetryService = async (
    serviceId: string,
    eventId: string
): Promise<IServiceEvent[]> => {
    const api = await Api();
    const data = { serviceId, eventId };
    const apiResponse = await api
        .post(`dashboard-ui/service/retry`, data)
        .then((result) => {
            return result.data.data;
        });

    return apiResponse;
};
